import clsx from 'clsx'

export function Input({
  className,
  trailingIcon,
  ...props
}: {
  className?: string
  trailingIcon?: React.ReactNode
} & React.InputHTMLAttributes<HTMLInputElement>) {
  if (trailingIcon) {
    return (
      <div className="grid grid-cols-1">
        <input
          className={clsx(
            'col-start-1 row-start-1 block w-full rounded-lg border border-gray-300 py-2 pl-3 pr-12 focus:border-black focus:outline-none focus:ring-1 focus:ring-black',
            className,
          )}
          {...props}
        />
        <span className="pointer-events-none col-start-1 row-start-1 mr-3 self-center justify-self-end text-gray-400">
          {trailingIcon}
        </span>
      </div>
    )
  }
  return (
    <input
      className={clsx(
        'w-full rounded-lg border border-gray-300 px-3 py-2 focus:border-black focus:outline-none focus:ring-1 focus:ring-black',
        className,
      )}
      {...props}
    />
  )
}
